function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/*********************************************************************************
 GAME ANIMATION

	This file contains the sub library of game animations making it (slightly) easier
	to create/copy a game element and move it across the screen to a predetermined 
	location. 
 

**********************************************************************************/
var GameAnimation = /*#__PURE__*/function () {
  function GameAnimation() {
    _classCallCheck(this, GameAnimation);
  }
  return _createClass(GameAnimation, [{
    key: "timeout",
    value:
    //
    // Make a function async and await timeout to pause game execution
    //
    function timeout(ms) {
      return new Promise(function (res) {
        return setTimeout(res, ms);
      });
    }
  }, {
    key: "runAnimationQueue",
    value: function () {
      var _runAnimationQueue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var timer,
          nextStep,
          callback,
          params,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              timer = _args.length > 0 && _args[0] !== undefined ? _args[0] : 50;
              if (!(this.animationSequence.length == 0)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              console.debug("GT: Sequencing ".concat(this.animationSequence.length, " Animations"));
              console.info('GT: Halt game for animation');
              this.halted = 1;
            case 2:
              if (!(this.animationSequence.length > 0)) {
                _context.n = 7;
                break;
              }
              nextStep = this.animationSequence.shift();
              callback = nextStep.callback, params = nextStep.params;
              console.debug('GT: Animation: ', JSON.parse(JSON.stringify(params)));
              if (!nextStep.delay) {
                _context.n = 3;
                break;
              }
              _context.n = 3;
              return this.timeout(nextStep.delay);
            case 3:
              if (callback) {
                callback.apply(this, params);
              }
              if (!(this.animationSequence.length > 0)) {
                _context.n = 5;
                break;
              }
              _context.n = 4;
              return this.timeout(timer);
            case 4:
              _context.n = 6;
              break;
            case 5:
              console.info('GT: Animation Sequence Finished');
              return _context.a(2);
            case 6:
              _context.n = 2;
              break;
            case 7:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function runAnimationQueue() {
        return _runAnimationQueue.apply(this, arguments);
      }
      return runAnimationQueue;
    }()
  }, {
    key: "copyGameElement",
    value: function copyGameElement(target) {
      var target_obj = typeof target === 'string' ? document.querySelector(target) : target;
      if (!target_obj) {
        console.warn('GT: Objects not found! ', target);
        return null;
      }
      var source_stats = target_obj.getBoundingClientRect();

      //Find a unique ID for our container
      var i = 0;
      var _iterator = _createForOfIteratorHelper(document.querySelectorAll('.animated_elem')),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var helper = _step.value;
          var temp_id = helper.id.replace('ae', '');
          if (parseInt(temp_id) >= i) {
            i = parseInt(temp_id) + 1;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var divid = 'ae' + i;

      //Create temporary container
      this.app.browser.addElementToDom("<div id=\"".concat(divid, "\" class=\"animated_elem\"></div>"));

      //Set properties
      var this_helper = document.getElementById("".concat(divid));
      this_helper.style.top = "".concat(source_stats.top, "px");
      this_helper.style.left = "".concat(source_stats.left, "px");
      this_helper.style.height = "".concat(source_stats.height, "px");
      this_helper.style.width = "".concat(source_stats.width, "px");
      this_helper.style.zIndex = 100 + i;
      var as = "".concat(this.animationSpeed / 1000, "s");
      this_helper.style.transition = "left ".concat(as, ", top ").concat(as, ", width ").concat(as, ", height ").concat(as, ", opacity ").concat(this.animationSpeed * 3 / 2000, "s");

      //Fall back if we haven't defined the hidden class
      //target_obj.style.visibility = "hidden";

      //Copy the element we want to move
      var clone = target_obj.cloneNode(true);
      clone.id = '';
      clone.style.top = '';
      clone.style.bottom = '';
      clone.style.left = '';
      clone.style.right = '';

      //Hide the original (We make the copy so that any flex/grid layouts don't suddenly snap out of place)
      target_obj.classList.add('copied_elem');

      //Insert copy in the element that moves
      this_helper.append(clone);
      //clone.style.visibility = null;

      return divid;
    }

    /**
     *  @param HTML the html for the object to create
     *  @param origin_reference a selector for an element in the DOM that will be there reference for the initial top/left of the created element
     *  @param dimension_reference (optional) a selector for an element to serve as the initial reference for height/width of the created element
     */
  }, {
    key: "createGameElement",
    value: function createGameElement(html, origin_reference) {
      var dimension_reference = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (!document.querySelector(origin_reference) || dimension_reference && !document.querySelector(dimension_reference)) {
        return null;
      }
      var source_stats = document.querySelector(origin_reference).getBoundingClientRect();
      var destination_stats = dimension_reference ? document.querySelector(dimension_reference).getBoundingClientRect() : source_stats;

      //Find a unique ID for our container
      var i = 0;
      var _iterator2 = _createForOfIteratorHelper(document.querySelectorAll('.animated_elem')),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var helper = _step2.value;
          var temp_id = helper.id.replace('ae', '');
          if (parseInt(temp_id) >= i) {
            i = parseInt(temp_id) + 1;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var divid = 'ae' + i;
      this.app.browser.addElementToDom("<div id=\"".concat(divid, "\" class=\"animated_elem\">").concat(html, "</div>"));
      var this_helper = document.getElementById("".concat(divid));
      this_helper.style.top = "".concat(source_stats.top, "px");
      this_helper.style.left = "".concat(source_stats.left, "px");
      this_helper.style.height = "".concat(destination_stats.height, "px");
      this_helper.style.width = "".concat(destination_stats.width, "px");
      this_helper.style.zIndex = 100 + i;
      var as = "".concat(this.animationSpeed / 1000, "s");
      this_helper.style.transition = "left ".concat(as, ", top ").concat(as, ", width ").concat(as, ", height ").concat(as);
      return divid;
    }

    /*
    Useful Options:
        1) callback -- function to run on moving object at beginning of motion
        2) resize -- resize object to that of it's destination
        3) insert -- append object in destination at end of animation
        4) run_all_callbacks -- a flag to run each animations callback up completion
     */
  }, {
    key: "moveGameElement",
    value: function moveGameElement(animatedObjId, destination, options) {
      var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var game_self = this;
      var destination_obj = typeof destination === 'string' ? document.querySelector(destination) : destination;
      if (!destination_obj) {
        console.warn('GT: Object not found: destination', destination);
        return null;
      }
      this.animation_queue.push(animatedObjId);
      var destination_stats = destination_obj.getBoundingClientRect();
      if (!document.getElementById(animatedObjId)) {
        console.warn('GT: No object to animate!');
      }
      $("#".concat(animatedObjId)).delay(10).queue(function () {
        //Flexible callback to add effect during move
        if (options !== null && options !== void 0 && options.resize) {
          $(this).children().css('width', '100%');
          $(this).css({
            width: "".concat(destination_stats.width, "px"),
            height: "".concat(destination_stats.height, "px")
          });
        }
        $(this).children().css('visibility', '');
        if (options !== null && options !== void 0 && options.callback) {
          options.callback(animatedObjId);
        }
        $(this).css({
          top: "".concat(destination_stats.top, "px"),
          left: "".concat(destination_stats.left, "px")
        }).dequeue();
      }).delay(game_self.animationSpeed).queue(function () {
        var item = this;
        if (options !== null && options !== void 0 && options.insert) {
          item = $(this).children()[0];
          $(destination + ' .copied_elem').remove();
          document.querySelector(destination).append(item);
        }
        $(this).addClass('done'); //Still used???
        game_self.animation_queue.shift();
        if (game_self.animation_queue.length == 0 && game_self.animationSequence.length == 0) {
          if (options !== null && options !== void 0 && options.insert) {
            $('.copied_elem').remove();
          } else {
            $('.copied_elem').removeClass('copied_elem');
          }
          if (callback) {
            callback(item);
          } else {
            $('.animated_elem').remove();
          }
        } else if ((options === null || options === void 0 ? void 0 : options.run_all_callbacks) == true) {
          if (callback) {
            callback(item);
          }
        }
        $(this).dequeue();
      });
    }
  }]);
}();
module.exports = GameAnimation;